import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 |  exponentialStrength:10}}
 *   formats to: 1024
*/
@Pipe({name: 'removeChar'})
export class RemoveCharPipe implements PipeTransform {
  transform(value: String, char: string): String {

    return value.replace(/-/g, '');
  }
}


// WEBPACK FOOTER //
// ./src/app/tms/remove-char-pipe.ts